import React from 'react';
import RajyotsavaDay2023 from 'views/RajyotsavaDay2023'

const SchoolProgrampage = () => {
  return <RajyotsavaDay2023 />;
};

export default SchoolProgrampage;